import o from"./well-known-symbol.js";var t=o,a=t("match"),c=function(e){var r=/./;try{"/./"[e](r)}catch{try{return r[a]=!1,"/./"[e](r)}catch{}}return!1};export{c as default};
